import { graphql } from "api/cms-website/generated";

import { IconFragment } from "../primitives/icon";

export const VerticalListWithImageItemFragment = graphql(/* GraphQL */ `
    fragment VerticalListWithImageItemFragment on ComponentElementsVerticalListWithImageItem {
        title
        text
        icon {
            ...IconFragment
        }
    }
    ${IconFragment}
`);
